import gql from 'graphql-tag';

export const disclosureFragment = gql`
    fragment Disclosure on SelectiveDisclosure {
        asOfDate
        totalHoldings
        totalIssuers
        top10Percentage
        top10EquityPercentage
        top10CalculatedPercentage
        individualHoldings {
            holdingCouponRate
            holdingMaturityDate
            name
            rank
            percentTotalNetAssets
        }
    }
`;

export const etfDisclosureFragment = gql`
    fragment ETFDisclosure on TopTenHolding {
        asOfDate
        individualHoldings {
            rank
            name
            sectorName
            industryName
            countryName
            marketValue
            percentTotalNetAssets
            holdingCouponRate
            holdingMaturityDate
            previousQuarterChange
        }
        totalHoldings
        top10Percentage
    }
`;
